module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-1-1.f26cbb0a.png";